// Please update the version only when pushed to web environment
export default {
  // version of product, please increase when pushing changes
  version: '1.0.65',
  // flag  to enable features under test environment
  DEBUG: false,
  login: {
    clientSecret: 'FvgpqmRajFLy5RAW2OpdHH7R4yW1aZjAWjVt394e',
  },
  dss: {
    // domain: 'start.superlinda.nl',
     domain: 'start.superlinda.nl',
    // domain: 'start.superlinda.nl',
    port: 4010,
    environmentName: 'TheDrivingForce',
    accountManagerObjectId: 'LocationsNode_AM',
  },
  webSession: {
    // websession
    domain: 'start.superlinda.nl',
    port: 11581,
  },
  Userlogin: {
    clientId: 1,
    clientSecret: 'Ygjn5YaXZVDxJrnekZtsmdDPgQphVu03iFtKZTSc',
  },
  map: {
    // map stuff
    center: [4.839374, 52.241618],
    zoom: 12,
    minZoom: 4,
    maxZoom: 18,
  },
  tileServer: {
    // Connectivity through the tile server using tile.thedrivingforce.nl
    base: 'https://tile.thedrivingforce.nl/osm_tiles',
    url: 'https://tile.thedrivingforce.nl/osm_tiles/{z}/{x}/{y}.png',
  },
  maxSize: {
    arrivalAudioSize: 1048576,
    departureAudioSize: 1048576,
    pictureSize: 1048576,
    logo: {
      h: 120,
      w: 475,
    },
    home: {
      h: 720,
      w: 1280,
    },
  },
    partnerSubdomain: 'ruizendaal',
  // partnerSubdomain: 'torsius-ei',
  // partnerSubdomain: 'de-hooiberg',
  // partnerSubdomain: 'amsterdamislands',
  // partnerSubdomain: 'vanegmond',
  // partnerSubdomain: 'het-binnenveld',
  // partnerSubdomain: 'luysterburg',
  // partnerSubdomain: 'booijkaasmakers',
  // partnerSubdomain: 'slagerij-konijn',
  // partnerSubdomain: 'hoeve-kazan',
  // partnerSubdomain: 'lagerweij-eieren',  // ProfessionalBeta
  // partnerSubdomain: 'bosheurne',
  // partnerSubdomain: 'broekmans-patisserie',
  // partnerSubdomain: 'thedrivingforce',
  // partnerSubdomain: 'buyfresh',
  // partnerSubdomain: 'meester-poeliers', // Luxury ViewType
  // partnerSubdomain: 'bosmantel',   // Classic ViewType
  // partnerSubdomain: 'flikkenkoning',  // Selling ViewType
  // partnerSubdomain: 'proevkantoor', // Story ViewType
  // partnerSubdomain: 'puur-berkshire',
  // partnerSubdomain: 'carwash',
  //  partnerSubdomain: 'eierhandelwegdam',
  // partnerSubdomain: 'eierhandelvanbeek',
  // partnerSubdomain: 'thecompanykitchen',
};
